var path = '/home/travis/build/orizens/echoes/src/core/components/e-dropdown/e-dropdown.tpl.html';
var html = "<div class=e-dropdown uib-dropdown is-open=vm.status.isOpen><div class=dropdown-toggle uib-dropdown-toggle ng-disabled=disabled><i class=\"glyphicon glyphicon-{{vm.icon}}\"></i> {{vm.label}} <span class=\"label label-primary\">{{ vm.displayLabel }}</span> <span class=caret></span></div><ul class=\"uib-dropdown-menu dropdown-menu-fade dropdown-menu\" role=menu><li ng-repeat=\"item in vm.items\" ng-click=\"vm.handleClick(item, $index)\" ng-class=\"{'active': $index === vm.activeIndex}\"><a>{{item}}</a></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/core/components/e-dropdown/e-dropdown.tpl.html
 ** module id = 139
 ** module chunks = 1
 **/